import { Box, Button, IconButton, Input, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import CustomAlert from "../../events/components/CustomAlert"
import { updateReviewState } from "../../../redux/reviewSlice";
import { useDispatch, useSelector } from "react-redux";
import CheckIcon from "../../../components/icons/CheckIcon";
import edit from '../../../assets/editExtendIcon.svg'
import { updateCreationState } from "../../../redux/eventCreationSlice";
import { generateDarkColor, setInput, timeStampToDateString, timeStampToDayString, timeStampToNumberedDateString } from "../../../utils/commonServices";
import { LoadingButton } from "@mui/lab";
import { updateTeamState } from "../../../redux/teamSlice";
import CustomInput from "../../eventcreation/components/CustomInput";
import CustomAutocomplete from "../../eventcreation/components/CustomAutoComplete";
import CustomButton from "../../../components/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import OrganisationMembersList from "./OrganisationMembersList";
import { updateState } from "../../../redux/commonSlice";



const ViewOrganisationMembersPopup = (props) => {
    const {  options } = props
   
    const dispatch = useDispatch()
    const [searchTerm, setSearchTerm] = useState('');
    const teamsReducer = useSelector((state) => state.root.teamsReducer);
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
    const [members, setMembers] = useState(commonReducer.organisation_members_list)
  
   
    const [searchedArray, setSearchedArray] = useState(members)
    const colors = ['red', 'pink', 'black'];

   



    
    useEffect(()=>{
      setSearchedArray(commonReducer.organisation_members_list)
    },[commonReducer.organisation_members_list])
  


    const handleClose = () => {
      dispatch(updateState({view_members_popup : false}))      
    };

  

    const handleSearch = (e) => {
      const searchedInput = e.target.value.toLowerCase();
      if (!searchedInput.startsWith(' ')) {
        setSearchTerm(searchedInput);
      }
        // const searchedInput = e.target.value.toLowerCase().trim();
        // setSearchTerm(searchedInput);
    
        const updatedFiles = [...members];
    
        const results = updatedFiles?.filter(item =>
          item.name?.toLowerCase().includes(searchedInput) ||
          item.email?.toLowerCase().includes(searchedInput)||
          item.role?.name?.toLowerCase().includes(searchedInput)
        );
        setSearchedArray(results);
      };

    return (
        <CustomAlert 
          open={commonReducer.view_members_popup} 
          handleClose={handleClose} 
          height={{xs:'420px', md:'75%',lg:'70%',xl:'600px'}}
          width={{md:'65%',lg:'65%', xl:'1400px'}}
          rightComponent={
            <Box component='div' className= 'flex col a-start' sx={{paddingX:{xs:'10px',md:'1rem', lg:'1.2rem', xl:'2rem'},height:'100%',  overscrollBehaviorBlock:'contain', overflowY:'auto', width:'100%', justifyContent:{md:'center'}, paddingTop:{xs:2,sm:3, md:1, lg:0}}}>
            {/* <Box  sx={{height: '100%',  overscrollBehaviorBlock:'contain', overflowY:'auto', width:'100%', justifyContent:{sm:'center'}}} className='flex col a-start'>  */}
              <Typography sx={{fontSize:{xs:'8px',md:'9px',lg:'10px', xl:'14px'}, fontWeight:600, fontFamily:'Rubik', color:'#000'}} >{`Admin(Project Manager)`}</Typography>
              <Box component='ul' pl={1} mt={0} style={{listStyleType: 'disc'}} mb={{xs:1, md:1.5, lg:2.5}}>
              <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>Oversees video projects </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik',textAlign:'justify', color:'#000'}}>Assigns editors </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>Manages timelines and deliverables  </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik',textAlign:'justify', color:'#000'}}>Reviews uploaded videos </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>Submits revision requests  </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik',textAlign:'justify', color:'#000'}}>Ensures all client feedback is addressed </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik',textAlign:'justify', color:'#000'}}>Approves Final Videos  </Typography>
              </Box>

           
              <Typography sx={{fontSize:{xs:'8px',md:'9px',lg:'10px', xl:'14px'}, fontWeight:600, textAlign:'justify', fontFamily:'Rubik', color:'#000'}}>Editors</Typography>
              <Box component='ul' pl={1} style={{listStyleType: 'disc'}} mt={0}  mb={{xs:1, md:1.5, lg:2.5}}>
              <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>Reviews client and PM feedback </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>Edits videos and applies revision notes</Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>Tracks tasks using the checklist </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>Uploads new video versions</Typography>
              </Box>
             
            {/* </Box> */}
          </Box>}
          >       
            <Box sx={{display:'flex', flexDirection:'column', height:'100%'}} px={4} pt={3} pb={2}>
              <Box flexGrow={1} pt={4} >    
                  {/* <Box className='flex col' gap={1.5}>
                    <Box className='flex j-between a-center'>
                      <Typography style={{fontWeight:600}}>Members ({testmembers?.length})</Typography>
                      <Box id="search" >
                        <Input
                        value={searchTerm}
                        onChange={handleSearch}
                        sx={{
                          //  minWidth: '160px',
                            borderBottom: 1,
                            borderColor: "#333333",
                            input: {
                                fontSize: { xs: '12px', md: '12px', lg: '13px', xl: '16px' },
                                fontWeight: 400,
                                color: "#000000",
                            },
                            width:'60%', 
                            // mr:5
                        }}
                        placeholder="Search"
                        startAdornment={
                            <IconButton sx={{paddingBottom:0.5, fontSize: {xs:'12px',md:'14px',lg:'17px',xl:'24px'}, '& .MuiSvgIcon-root':{fontSize:{xs:'12px',md:'14px',lg:'15px',xl:'20px'}}, paddingRight:2}} >
                                <SearchIcon style={{ color: "#000000" }} />
                            </IconButton>
                        }
                        />
                    </Box>
                    </Box>
                    <Box sx={{height:'28vh', overflowY:'auto'}}>

                      {searchedArray.length > 0 && searchedArray.map((member, index) => {
                        return  <MembersList  member={member} index={index} testmembers={searchedArray} setTestmembers={setSearchedArray}/>
                      })}
                    </Box>
                  </Box> */}
                  <Box className='flex col' gap={1.5} >
                    <Box className='flex j-between a-center' style={{width:{xs:'90%', md:'80%'}}}>
                      <Typography sx={{fontWeight:600, fontFamily:'Rubik', color:'#000', fontSize:{xs:'16px',sm:'16px',md:'18px',lg:'20px',xl:'27px'}}}>Members ({members?.length})</Typography>
                      <Box id="search" className='flex j-end' pr={2}>
                        <Input
                          id="search-input"
                        value={searchTerm}
                        onChange={handleSearch}
                        inputProps={{ maxLength: 50 }}
                        sx={{
                            borderColor: "transparent",
                            input: {
                                fontSize: { xs: '12px', md: '12px', lg: '13px', xl: '16px' },
                                fontWeight: 400,
                                color: "#000000",
                              
                            },
                           
                            justifySelf:'flex-end',
                            width:'60%', 
                            transition: 'width 0.3s ease',
                    
                        }}
                        placeholder="Search"
                        startAdornment={
                            <IconButton sx={{paddingBottom:0.5, fontSize: {xs:'12px',md:'14px',lg:'17px',xl:'24px'}, '& .MuiSvgIcon-root':{fontSize:{xs:'12px',md:'14px',lg:'15px',xl:'20px'}}, paddingRight:2}} >
                                <SearchIcon style={{ color: "#000000" }} />
                            </IconButton>
                        }
                        />
                    </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 2, pb: 0.5, borderBottom: '1px solid #E8EAF0' }}>
                      <Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '8px', md: '9px', lg: '10px', xl: '13px' }, fontWeight: 600, color: '#888' }}>Member</Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '8px', md: '9px', lg: '10px', xl: '13px' }, fontWeight: 600, color: '#888' }}>Auto-assign</Typography>
                        <Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '8px', md: '9px', lg: '10px', xl: '13px' }, fontWeight: 600, color: '#888' }}>Role</Typography>
                      </Box>
                    </Box>
                    <Box sx={{height:'30vh', overflowY:'auto'}} pr={2}>

                      {searchedArray.length > 0 ? searchedArray.map((member, index) => {
                        return  <OrganisationMembersList key={index} color={generateDarkColor(member, 'name')} member={member} index={index} searchedArray={searchedArray} roleOptions={options}/>
                      }): 
                       <Box className= 'flex col j-center a-center' sx={{overflowY: "initial", whiteSpace: 'normal'}} height='100%' width='100%'>
                          <Typography sx={{fontSize: 20, color: '#878887', fontWeight: 300, textAlign: 'center', fontFamily:'Rubik'}} >No results found.
                          </Typography>
                        </Box>
                      }
                  
                    </Box>
                  </Box>
  
              </Box>
          </Box>
       
        </CustomAlert>
      )
}

export default ViewOrganisationMembersPopup
